import { Component } from '@angular/core';

import { BaseComponent } from '~/pages/base.component';
import { AppStateService } from '~/services/app-state.service';
import { GraphService } from '~/core/services/graph.service';
import { AppSettingsService } from '~/core/services/appsettings.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})

export class HomeComponent extends BaseComponent {

    public userName = '';
    public userInitials = '';
    public userPhoto = '';
    public showPhoto = false;

    constructor(
        private state: AppStateService,
        private graphService: GraphService,
        private appSettingsService: AppSettingsService,
    ) {
        super();
    }

    //*************************************************************************
    //  Component Life-Cycle Methods
    //*************************************************************************
    public override async ngOnInit() {
        await super.ngOnInit();

        this.title = 'Notification Agent';
        this.isLoading = false;
        this.state.initializeConversationState();
        this.loadUserInfo();
    }

    //*************************************************************************
    //  Private Methods
    //*************************************************************************
    private async loadUserInfo(): Promise<void> {
        const settings = await this.appSettingsService.getSettings();
        const user = settings.user;
        if (!user) {
            return;
        }

        this.userName = user.name || '';
        this.userInitials = user.initials || '';
        this.state.userInitials.set(this.userInitials);

        if (user.photo) {
            this.userPhoto = user.photo;
            this.showPhoto = true;
            this.state.userPhoto.set(user.photo);
            return;
        }

        this.graphService.getUserPhoto().then((photo: any) => {
            if (photo && photo !== 'x') {
                this.userPhoto = photo;
                this.showPhoto = true;
                this.state.userPhoto.set(photo);
                user.photo = photo;
                this.appSettingsService.saveSettings(settings);
            }
        });
    }
}
